<template>
   <div>
        <template v-if="data.processflag==='1'">
            
            <template v-if="data.dockflag==='1'">

                <template v-if="data.pushstyle==='0'">
                    <my-tag 
                        type="primary">
                            {{data.jyzxname}}--无需推送
                    </my-tag>
                </template>

                <template v-if="data.pushstyle==='1'||data.pushstyle==='2'">

                    <template v-if="data.jyzxcode=='J13053001'">
                        <my-tag 
                            type="success">
                                {{data.jyzxname}}--已推送
                        </my-tag>
                    </template>

                    <template v-else>
                        <template v-if="data.xtts==='1'">
                            <my-tag 
                                type="success">
                                    {{data.jyzxname}}--已推送
                            </my-tag>
                        </template>

                        <template v-else>
                            <my-tag 
                                type="primary">
                                    {{data.jyzxname}}--待自动推送
                            </my-tag>
                        </template>
                    </template>
                    
                    
                </template>

            </template>
            <template v-if="data.dockflag!=='1'">
                <my-tag 
                    type="primary">
                        {{data.jyzxname}}
                </my-tag>
            </template>
        </template>    
        <template v-else>
            <template v-if="data.xtts!=='1'">
                <my-tag 
                    type="primary">
                        
                </my-tag>
            </template>
        </template>
      
   </div>
</template>

<script>


export default {
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
           form:{}
        }
    },
    methods:{
        
    },
    computed: {
        
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
</style>
